import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Nullable } from '~/types/Nullable';

export interface State {
  id: Nullable<string>;
  departmentTree: any[];
  folderTree: any;
}

export const initialState: State = {
  id: null,
  departmentTree: [],
  folderTree: {},
};

export default createSlice({
  name: 'client',
  initialState,

  selectors: {
    selectClient: (state) => state,
  },
  reducers: {
    clientSet: (
      state,
      action: PayloadAction<{
        id: any;
        departmentTree: any[];
        folderTree: any;
      }>,
    ) => {
      const { id, departmentTree, folderTree } = action.payload;
      state.id = id;
      state.departmentTree = departmentTree;
      state.folderTree = folderTree;
    },
    clientSetFolderTree: (state, action: PayloadAction<any>) => {
      state.folderTree = action.payload;
    },
  },
});
